export default {
    BOUNCE: "bounce",
    COMPLAINT: "complaint",
    INTERNAL_PARTICIPANT: "ivrsurveyinternalparticipantconnected",
    DISABLED_SURVEY_FORM: "ivrsurveyformdisabled",
    UNSPECIFIED: "unspecified",
};
